module.exports = __webpack_public_path__ + "static/fonts/DaimlerCS-Demi.402e62ca.eot";